<template>
  <div v-loading.body="loading">
    <el-menu
      :default-active="$route.path"
      class="el-menu-demo"
      mode="horizontal"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#409EFF"
      router
    >
      <el-menu-item index="/home/wavepicking/wavepickinglist"
        >波次单列表</el-menu-item
      >
      <el-menu-item index="/home/aswavepicking/aswavepickinglist"
        >售后波次</el-menu-item
      >
      <el-menu-item index="/home/wavepicking/TempSummaryList/5"
        >质检汇总</el-menu-item
      >
      <el-menu-item index="/home/wavepicking/TempSummaryList/6"
        >改标汇总</el-menu-item
      >
      <el-menu-item index="/home/surpassSummary/surpassSummaryPickingList"
        >中分汇总拣货</el-menu-item
      >
    </el-menu>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item>
                    <el-select
                      v-model="search_type"
                      placeholder="波次号"
                      style="width: 150px"
                    >
                      <el-option
                        v-for="item in search_options"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item style="margin-left: -15px; width: 165px">
                    <el-input
                      v-model="search_value"
                      placeholder="请输入搜索内容"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.status"
                      placeholder="请选择状态"
                      style="width: 150px"
                    >
                      <el-option
                        v-for="item in conditionData.status"
                        :key="item.status_id"
                        :label="item.status_name"
                        :value="item.status_id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.type"
                      placeholder="请选择波次类型"
                      style="width: 150px"
                    >
                      <el-option value="">全部</el-option>
                      <el-option
                        v-for="item in conditionData.as_type"
                        :key="item.type_id"
                        :label="item.type_name"
                        :value="item.type_id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.is_generate_picking_task"
                      placeholder="是否生成拣货任务"
                      style="width: 150px"
                    >
                      <el-option value="">全部</el-option>
                      <el-option
                        v-for="item in conditionData.generate_picking_task"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.is_remark"
                      multiple
                      placeholder="有无备注"
                      style="width: 150px"
                    >
                      <el-option
                        v-for="item in remarks"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="波次时间：" style="width: 500px">
                    <el-date-picker
                      v-model="form.create_time"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :default-time="['06:00:00', '06:00:00']"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      style="background-color: #e1e1e1"
                      @click="resetCondition"
                      >重置</el-button
                    >
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="search">
                      查询波次</el-button
                    >
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="show_statistics = true">
                      统计数据查看</el-button
                    >
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      type="primary"
                      @click="is_show_search_option = !is_show_search_option"
                    >
                      <i class="el-icon-arrow-down" />
                    </el-button>
                  </el-form-item>
                  <div v-if="is_show_search_option">
                    <el-form-item>
                      <el-select
                        v-model="form.shipping_company"
                        placeholder="选择快递公司"
                        style="width: 150px"
                      >
                        <el-option
                          v-for="item in conditionData.express"
                          :key="item"
                          :label="item"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.is_stop_shipping"
                        placeholder="是否拦截"
                        style="width: 150px"
                      >
                        <el-option value="">全部</el-option>
                        <el-option
                          v-for="item in conditionData.is_stop_shipping"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.full_allot"
                        placeholder="是否配齐"
                        style="width: 150px"
                      >
                        <el-option
                          v-for="item in is_pq"
                          :key="item.key"
                          :label="item.name"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="波次待发数量">
                      <el-input
                        v-model="form.wave_picking_num"
                        placeholder="波次待发数量"
                        style="width: 150px"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="~">
                      <el-input
                        v-model="form.wave_picking_num_end"
                        placeholder="波次待发数量"
                        style="width: 150px"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.province"
                        multiple
                        filterable
                        placeholder="省"
                        @change="getCity"
                      >
                        <el-option
                          v-for="item in conditionData.province"
                          :key="item.region_id"
                          :label="item.region_name"
                          :value="item.region_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.city"
                        multiple
                        filterable
                        placeholder="市"
                        @change="getDistrict"
                      >
                        <el-option
                          v-for="item in cityData.list"
                          :key="item.region_id"
                          :label="item.region_name"
                          :value="item.region_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.district"
                        multiple
                        filterable
                        placeholder="区"
                      >
                        <el-option
                          v-for="item in districtData.list"
                          :key="item.region_id"
                          :label="item.region_name"
                          :value="item.region_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="出库时间：">
                      <el-date-picker
                        v-model="form.out_time"
                        :default-time="['06:00:00', '06:00:00']"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        style="width: 350px"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </div>
                </el-form>
              </el-col>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24" style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          数据汇总 &nbsp;&nbsp;&nbsp;&nbsp;波次单数量：{{ resData.total }}
          <!--&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;订单数量：{{resData.info_total}}-->
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;波次商品待发数量：{{
            resData.sku_num
          }}
        </div>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>

          <el-button
            style="margin-left: auto"
            type="danger"
            size="mini"
            @click="mergeWavePicking"
            >合并波次</el-button
          >
          <el-dropdown
            split-button
            type="primary"
            size="mini"
            @click="lockWavePicking(0)"
            @command="lockWavePicking"
          >
            锁定波次
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">全部锁定波次</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!--                    <el-button style="" type="primary" size="mini" @click="lockWavePicking">锁定波次</el-button>-->
          <el-button
            style=""
            type="primary"
            size="mini"
            @click="generateTaskBefore"
            >生成拣货任务</el-button
          >
          <el-button
            style=""
            type="danger"
            size="mini"
            @click="unlockWavePickingByIds"
            >批量解锁</el-button
          >

          <el-button style="" type="danger" size="mini" @click="waybillDiscard">
            取消面单</el-button
          >
          <el-button type="success" size="mini" @click="printWavePicking">
            打印配货单</el-button
          >
          <el-button
            style="margin-right: 10px"
            type="success"
            size="mini"
            @click="shippingVisible = true"
            >修改快递公司</el-button
          >
          <el-dialog title="请选择快递公司" :visible.sync="shippingVisible">
            <el-form :model="form">
              <el-form-item label="快递公司">
                <el-select
                  v-model="form.express"
                  placeholder="请选择快递公司"
                  @change="getSenders"
                >
                  <el-option
                    v-for="express in conditionData.express"
                    :key="express"
                    :label="express"
                    :value="express"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="form.express != '物流'" label="网点">
                <el-select
                  v-if="form.express != '物流公司'"
                  v-model="form.sender_id"
                  placeholder="请选择网点"
                >
                  <el-option label="无" value="0"></el-option>
                  <el-option
                    v-for="item in senders"
                    :key="item.sender_id"
                    :label="item.sender"
                    :value="item.sender_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="form.express == '物流'" label="物流公司">
                <el-select v-model="form.logistics_id" placeholder="请选择网点">
                  <el-option label="无" value="0"></el-option>
                  <el-option
                    v-for="item in conditionData.logistics"
                    :key="item.logistics_id"
                    :label="item.logistics_name"
                    :value="item.logistics_id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="shippingVisible = false">取 消</el-button>
              <!--<el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>-->
              <el-button type="primary" @click="updateShipping(0)">
                确 定</el-button
              >
            </div>
          </el-dialog>

          <el-upload
            style="margin: 0 10px 2px"
            :action="action"
            name="excel"
            :limit="1"
            :on-success="importFileWeight"
            :file-list="fileList"
            auto-upload
            with-credentials
          >
            <el-button size="mini" type="primary">导入重量</el-button>
          </el-upload>
          <el-button type="primary" size="mini" @click="exportExpress">
            导出电子面单</el-button
          >
          <el-button type="success" size="mini" @click="output">
            导出波次单</el-button
          >
          <el-button type="success" size="mini" @click="outputInfo">
            导出波次单明细</el-button
          >
          <el-button type="success" size="mini" @click="outputLog">
            导出改排日志</el-button
          >
          <el-button
            type="success"
            size="mini"
            style="margin-left: -5px"
            @click="show_log_time = !show_log_time"
            ><i class="el-icon-date"
          /></el-button>
          <el-date-picker
            v-if="show_log_time == 1"
            v-model="form.log_time"
            size="mini"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['06:00:00', '06:00:00']"
          >
          </el-date-picker>
          <field-setting page="2" @onsuccess="changeFields"></field-setting>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.data"
            tooltip-effect="dark"
            style="width: 100%"
            :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="right"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              prop="as_wave_picking_no"
              label="波次号"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.user_id"
              prop="user_id"
              label="用户ID"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.consignee"
              prop="consignee"
              label="收货人姓名"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.wave_picking_full_allot"
              prop="wave_picking_full_allot"
              label="是否配齐"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="as_wave_picking_type"
              label="波次类型"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="wave_picking_status"
              label="状态"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="wave_picking_is_generate_picking_task"
              label="是否生成拣货任务"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.wave_picking_mobile_hide"
              prop="wave_picking_mobile_hide"
              label="收货人手机"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.address"
              key="address"
              prop="address"
              label="收货人地址"
              show-overflow-tooltip
              align="left"
              width="200"
            >
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  circle
                  @click="beforeChangeAddress(scope.row)"
                ></el-button>
                <span>{{ scope.row.address }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="showFields.shipping_company"
              prop="shipping_company"
              label="快递公司"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.guarantee_value_formal"
              prop="guarantee_value_formal"
              label="是否保价"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sender"
              label="网点"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="shipping_type_formal"
              label="快递公司分配方式"
              show-overflow-tooltip
              align="center"
            ></el-table-column>

            <el-table-column
              v-if="showFields.wave_picking_is_put_picking_list"
              prop="wave_picking_is_put_picking_list"
              label="是否放置配货单"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  circle
                  @click="updateFields(scope.row, 'PutList')"
                ></el-button>
                <span>{{ scope.row.wave_picking_is_put_picking_list }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="showFields.wave_picking_picking_type"
              prop="wave_picking_picking_type"
              label="拣货属性"
              show-overflow-tooltip
              align="center"
              width="200px"
            >
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  circle
                  @click="updateFields(scope.row, 'PickingType')"
                ></el-button>
                <span>{{ scope.row.wave_picking_picking_type }}</span>
              </template>
            </el-table-column>

            <el-table-column
              v-if="showFields.shipping_num"
              prop="shipping_num"
              label="快递单号"
              width="120"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.wave_picking_num"
              prop="wave_picking_num"
              label="待发总件数"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.weight"
              prop="weight"
              label="重量"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.wave_picking_print_status"
              prop="wave_picking_print_status"
              label="面单状态"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <!--<el-table-column prop="wave_picking_pay_way" label="支付方式" show-overflow-tooltip align="center"></el-table-column>-->
            <el-table-column
              v-if="showFields.work_id"
              key="work_id"
              prop="work_id"
              label="工单id"
              width="180"
              align="center"
            >
              <template slot-scope="scope">
                <a
                  v-for="(order_value, order_key) in scope.row.work_id"
                  v-if="order_value"
                  :key="order_key"
                  style="width: 160px; margin: 0; cursor: pointer"
                >
                  {{ order_key + 1 }}.{{ order_value }}<br />
                </a>
              </template>
            </el-table-column>
            <el-table-column
              v-if="showFields.problem_name"
              key="problem_name"
              prop="problem_name"
              label="原工单问题"
              show-overflow-tooltip
              align="center"
            >
              <template v-if="problem_name_value" slot-scope="scope">
                <span
                  v-for="(problem_name_value, problem_name_key) in scope.row
                    .problem_name"
                  :key="problem_name_key"
                  >{{ problem_name_key + 1 }}.{{ problem_name_value }}<br
                /></span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="showFields.problem_desc"
              key="problem_desc"
              prop="problem_desc"
              label="问题描述"
              show-overflow-tooltip
              align="center"
            >
              <template v-if="problem_desc_value" slot-scope="scope">
                <span
                  v-for="(problem_desc_value, problem_desc_key) in scope.row
                    .problem_desc"
                  :key="problem_desc_key"
                  >{{ problem_desc_key + 1 }}.{{ problem_desc_value }}<br
                /></span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="showFields.service_desc"
              key="service_desc"
              prop="service_desc"
              label="客服备注"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  v-for="(service_desc_value, service_desc_key) in scope.row
                    .service_desc"
                  v-if="service_desc_value"
                  :key="service_desc_key"
                  >{{ service_desc_key + 1 }}.{{ service_desc_value }}<br
                /></span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="showFields.word_dbid_blp_note"
              key="word_bdi_blp_note"
              prop="word_dbid_blp_note"
              label="拆包备注"
              show-overflow-tooltip
              align="center"
            >
              <template v-if="value" slot-scope="scope">
                <span
                  v-for="(value, key) in scope.row.word_dbid_blp_note"
                  :key="key"
                  >[{{ key }}.{{ value }}]<br
                /></span>
              </template>
            </el-table-column>

            <el-table-column
              v-if="showFields.create_time"
              prop="create_time"
              label="波次时间"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.wave_picking_is_stop_shipping"
              prop="wave_picking_is_stop_shipping"
              label="是否拦截"
              width="100"
              align="center"
            ></el-table-column>

            <el-table-column
              v-if="showFields.update_time"
              prop="update_time"
              label="更新时间"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.sk_time"
              prop="sk_time"
              label="最近物流时间"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.sk_content"
              prop="sk_content"
              label="最近物流信息"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.shipping_kdniao_state"
              prop="shipping_kdniao_state"
              label="物流状态"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(scope.row)"
                  >查看详情</el-button
                ><br
                  v-if="scope.row.status == 4 && scope.row.print_status != 1"
                />
                <el-button
                  v-if="scope.row.status == 4 && scope.row.print_status != 1"
                  type="text"
                  size="small"
                  @click="reCheck(scope.row)"
                  >重新校验</el-button
                ><br v-if="scope.row.print_status == 1" />
                <el-button
                  v-if="scope.row.print_status == 1"
                  type="text"
                  style="color: #67c23a"
                  size="small"
                  @click="rePrint(scope.row)"
                  >打印面单</el-button
                ><br />
                <el-button
                  v-if="scope.row.as_wave_picking_summary_id != 0"
                  type="text"
                  style="color: orange"
                  size="small"
                  @click="unLockWavePicking(scope.row.as_wave_picking_id)"
                  >解锁波次</el-button
                >
                <div v-if="scope.row.is_stop_shipping == 2">
                  <el-button
                    type="text"
                    size="small"
                    @click="toStop(scope.row.wave_picking_id, 1, scope.$index)"
                    >拦截</el-button
                  >
                </div>
                <div v-if="scope.row.is_stop_shipping == 1">
                  <el-button
                    type="text"
                    size="small"
                    @click="toStop(scope.row.wave_picking_id, 2, scope.$index)"
                    >取消拦截</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.total"
            :page-size="100"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>

        <el-dialog
          title="改排最多件"
          :visible.sync="delVisible"
          width="30%"
          center
        >
          <el-form :model="form">
            <el-form-item label="改排" prop="delNum">
              <el-input v-model="form.delNum" type="number" :max="skuNum">
                <template slot="append">
                  件,最多{{ skuNum }}件</template
                ></el-input
              >
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="delVisible = false">取 消</el-button>
            <el-button type="primary" @click="doRearrange()">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="输入修改地址" :visible.sync="changeAddressVisible">
          <el-form :model="form">
            <el-form-item>
              <el-input
                v-model="form.change_consignee"
                placeholder="收件人"
                @keyup.native.enter="search"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="form.change_wave_picking_mobile_hide"
                placeholder="手机"
                @keyup.native.enter="search"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="form.change_province"
                placeholder="省"
                @change="getCity"
              >
                <el-option
                  v-for="item in conditionData.province"
                  :key="item.region_id"
                  :label="item.region_name"
                  :value="item.region_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="form.change_city"
                placeholder="市"
                @change="getDistrict"
              >
                <el-option
                  v-for="item in cityData.list"
                  :key="item.region_id"
                  :label="item.region_name"
                  :value="item.region_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="form.change_district" placeholder="区">
                <el-option
                  v-for="item in districtData.list"
                  :key="item.region_id"
                  :label="item.region_name"
                  :value="item.region_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="form.change_address"
                placeholder="详细地址"
                @keyup.native.enter="search"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button
              type="danger"
              style="float: left"
              @click="recoveryConsignee(1)"
              >恢复至下单的收件信息</el-button
            >
            <el-button @click="changeAddressVisible = false">取 消</el-button>
            <el-button type="primary" @click="changeAddress">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <!--数据统计-->
    <div v-if="show_statistics">
      <statistics @onCloseDialog="show_statistics = false"></statistics>
    </div>
  </div>
</template>

<script>
import fieldSetting from "../wavepicking/components/fieldSetting";
import statistics from "../wavepicking/components/Statistics";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: { fieldSetting, statistics },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchCondition();
      vm.form.picking_assignment_no && vm.search();
    });
  },
  data() {
    const picking_assignment_no = this.$route.params.picking_assignment_no || 0;
    return {
      show_statistics: false,
      resData: {
        setting: "未配置数据",
      },
      conditionData: {},
      cityData: {},
      districtData: {},
      is_show_search_option: 0,
      search_type: picking_assignment_no
        ? "picking_assignment_no"
        : "wave_picking_no",
      search_options: [
        { key: "picking_assignment_no", name: "拣货任务单号" },
        { key: "wave_picking_no", name: "波次号" },
        { key: "dbid", name: "打标id" },
        { key: "work_id", name: "工单id" },
        { key: "sku", name: "SKU" },
        { key: "goods_no", name: "商品货号" },
        { key: "user_id", name: "用户id" },
        { key: "mobile", name: "用户手机号码" },
        { key: "shipping_num", name: "快递单号" },
      ],
      search_value: picking_assignment_no || "",
      form: {
        create_time: picking_assignment_no
          ? []
          : this.$excalibur.getDateTimeOnHours(-3, 6),
        log_time: this.$excalibur.getDateTimeOnHours(-30, 6),
        multipleSelection: [],
        change_district: 0,
        dbid: "",
        is_pu: 1,
        remark_wave_picking_id: 0,
        is_remark: "",
        picking_assignment_no,

        // 兼容弹窗不能输入的问题
        change_consignee: "",
        change_wave_picking_mobile_hide: "",
        change_province: "",
        change_city: "",
        change_district: "",
        change_address: "",
      },
      show_log_time: 0,
      loading: false,
      url: "/erp/AsWavePicking/getWavePickingList",
      origin: 1,
      type: 0,
      where: -1,
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      checkList: [],
      fileList: [],
      dialogTableVisible: false,
      dialogFormVisible: false,
      changeAddressVisible: false,
      splitVisible: false,
      ckRemarkVisible: false,
      wave_picking_id: 0,
      param: "",
      is_summary: 0, // 勾选的是否有汇总单的数据
      remarks: [
        // {"key" : '', "name" : "全部"},
        { key: 0, name: "无备注" },
        { key: 1, name: "未处理" },
        { key: 2, name: "已处理" },
      ],
      summary: [
        { key: 0, name: "全部" },
        { key: 1, name: "是" },
        { key: 2, name: "否" },
      ],

      is_pq: [
        { key: 0, name: "全部" },
        { key: 1, name: "是" },
        { key: 2, name: "否" },
      ],
      is_stock: [
        { key: 0, name: "全部" },
        { key: 1, name: "是" },
        { key: 2, name: "否" },
      ],
      payData: [
        { pay_id: 0, pay_name: "全部" },
        { pay_id: 1, pay_name: "在线支付" },
        { pay_id: 2, pay_name: "货到付款" },
      ],
      shippingAction: "",
      shippingVisible: false,
      websock: null,
      orders: [{}],
      skuNum: 0,
      delVisible: false,
      showFields: {},
      senders: [],
      action: `${apiBaseURL}/erp/AsWavePicking/importWeight`,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  created() {
    this.initWebSocket();
  },
  destroyed() {
    // 页面销毁时关闭长连接
    this.websocketclose();
  },
  // created() {
  //   this.fetchData();
  // },
  methods: {
    getSenders(val) {
      this.senders = [];
      for (const key in this.conditionData.senders) {
        if (this.conditionData.senders[key].shipping_company == val) {
          this.senders.push(this.conditionData.senders[key]);
        }
      }
      console.log(this.senders);
    },
    // 生成拣货任务之前检查
    generateTaskBefore() {
      // if (this.form.multipleSelection.length == 0) return this.$message.error('请勾选波次');
      this.$http
        .post("/erp/WavePicking/countingWavePicking", {
          the_ids: this.form.multipleSelection,
          generate_type: 4,
        })
        .then((rs) => {
          if (rs.data.code != 200) return this.$message.error(rs.data.msg);
          const d = rs.data.data;
          const msg = `已锁定波次数量: ${d.is_lock}, 单波次数量: ${d.picking_type_1}, 多波次数量: ${d.picking_type_2};   `;
          this.generateTask(msg);
        })
        .catch((_) => {
          return this.$message.error("获取数据错误, 请联系管理员");
        });
    },

    generateTask(msg) {
      this.$confirm(`${msg}是否确定生成拣货任务?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/PickingAssignment/generatePickingAssignment", {
              the_ids: this.form.multipleSelection,
              generate_type: 4,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              } else {
                const showCancelButton = false;
                this.$confirm(res.data.msg, "拣货任务生成结果", {
                  showCancelButton,
                });
                this.fetchData(true);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    changeAddress() {
      this.$http
        .post(
          `/erp/AsWavePicking/changeAddress/wave_picking_id/${this.wave_picking_id}`,
          this.filteredForm
        )
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
            this.fetchData(true);
            this.$set(this.form, "change_province", "");
            this.$set(this.form, "change_city", "");
            this.$set(this.form, "change_district", "");
            this.$set(this.form, "change_address", "");
            this.changeAddressVisible = false;
          }
        });
    },
    beforeChangeAddress(row) {
      this.wave_picking_id = row.wave_picking_id;
      this.$set(this.form, "change_province", row.province);
      this.$set(this.form, "change_city", row.city);
      this.$set(this.form, "change_district", row.district);
      this.getCity(row.province);
      this.getDistrict(row.city);
      this.$set(this.form, "change_address", row.address);
      this.$set(this.form, "change_consignee", row.consignee);
      this.$set(
        this.form,
        "change_wave_picking_mobile_hide",
        row.wave_picking_mobile_hide
      );
      this.changeAddressVisible = true;
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.is_stock == 1) {
        return "stock-row";
      }
      return "";
    },
    mergeWavePicking() {
      this.$confirm("是否确定合并波次?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/AsWavePicking/mergeWavePicking", this.filteredForm)
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message({
                  type: "info",
                  message: res.data.msg,
                });
              } else {
                this.$confirm(res.data.msg, "温馨提示", {
                  confirmButtonText: "知道了",
                  cancelButtonText: "I see",
                  type: "warning",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    lockWavePicking(val) {
      if (val == 1) {
        this.filteredForm.is_force = 1;
      } else {
        this.filteredForm.is_force = 0;
      }
      this.$http
        .post("/erp/AsWavePicking/beforeLock", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$confirm(
              `确定锁定波次?   波次数量：${res.data.data.count}  工单数量：${res.data.data.work_num}  商品数量：${res.data.data.wave_picking_num}`,
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                this.$http
                  .post("/erp/AsWavePicking/lockWavePicking", this.filteredForm)
                  .then((res) => {
                    if (res.data.code !== 200) {
                      this.$message.error(res.data.msg);
                    } else {
                      this.form.is_excel = 0;
                      if (res.data.code !== 200) {
                        this.$message.error(res.data.msg);
                      } else {
                        this.$message.success(res.data.msg);
                        this.fetchData(true);
                      }
                    }
                  });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消操作",
                });
              });
          }
        });
    },
    unlockWavePickingByIds() {
      this.$confirm("是否确定解锁波次?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/AsWavePicking/unLockWavePickingByIds", {
              wave_picking_ids: this.form.multipleSelection,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              } else {
                this.$message.success(res.data.msg);
                this.fetchData(true);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    unLockWavePicking(wave_picking_id) {
      this.$confirm("是否确定解锁波次?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/AsWavePicking/unLockWavePicking", {
              wave_picking_id,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              } else {
                this.$message.success(res.data.msg);
                this.fetchData(true);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    updateShipping(is_confirm = 0) {
      this.$http
        .post("/erp/AsWavePicking/updateShipping", {
          express: this.form.express,
          sender_id: this.form.sender_id,
          logistics_id: this.form.logistics_id,
          multipleSelection: this.form.multipleSelection,
          is_confirm,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            if (res.data.code == 402) {
              this.$confirm(
                `<div style='max-height: 80vh;overflow: auto'>${res.data.msg}<div>`,
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                  dangerouslyUseHTMLString: true,
                }
              )
                .then(() => {
                  this.updateShipping(1);
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消操作",
                  });
                });
            } else {
              this.$message.e(res.data.msg);
            }
          } else {
            this.shippingVisible = false;
            this.senders = [];
            this.$message.success(res.data.msg);
            this.fetchData(true);
          }
        });
    },
    updateFields(row, field) {
      this.$confirm("确认修改?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post(`/erp/WavePicking/update${field}`, {
              wave_picking_id: row.as_wave_picking_id,
              prefix: "as_",
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              } else if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              } else {
                this.$message.success(res.data.msg);
                this.fetchData(true);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 15);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    searchDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 3);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },
    logDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 30);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },
    output() {
      this.form.is_excel = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.loading = false;
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    outputLog() {
      this.form.is_excel = 1;
      this.loading = true;
      this.form.origin = this.origin;
      this.$http
        .post("/erp/WavePicking/getWavePickingLog", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.loading = false;
            this.form.is_excel = 0;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
    outputInfo() {
      this.form.is_excel = 1;
      this.loading = true;
      this.$http
        .post("/erp/AsWavePicking/exportWavePickingInfo/", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.form.is_excel = 0;
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      for (const key in val) {
        multipleSelection[key] = val[key].as_wave_picking_id;
      }
      this.form.multipleSelection = multipleSelection;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleClick(row) {
      this.$router.push(
        `/home/aswavepicking/aswavepickinginfo/${row.as_wave_picking_id}`
      );
    },
    reCheck(row) {
      this.$confirm("是否确定重新校验此波次?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/wavePicking/reCheck", {
              wave_picking_id: row.as_wave_picking_id,
              wave_picking_no: row.as_wave_picking_no,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message({
                  type: "info",
                  message: res.data.msg,
                });
              } else {
                this.$message({
                  type: "success",
                  message: "操作成功!",
                });
                this.fetchData();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    rePrint(row) {
      this.$confirm(
        "是否确定重新打印电子面单？（若无反应请刷新页面再打一次）",
        "提示",
        {
          confirmButtonText: "确定（请确认打印机是否正常）",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$http
            .post("/erp/AsWavePicking/rePirnt", {
              wave_picking_no: row.wave_picking_no,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message({
                  type: "info",
                  message: res.data.msg,
                });
              } else {
                this.websocketsend(JSON.stringify(res.data.data.printData));
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // websocket相关
    initWebSocket() {
      // 初始化weosocket

      const ishttps = document.location.protocol == "https:";
      if (ishttps) {
        var wsuri = "wss://localhost:13529"; // https wss地址
      } else {
        var wsuri = "ws://localhost:13528"; // ws地址
      }

      this.websock = new WebSocket(wsuri);
      // this.websocket.onopen = this.websocketonopen;

      this.websock.onerror = this.websocketonerror;

      this.websock.onmessage = this.websocketonmessage;
      this.websock.onclose = this.websocketclose;
    },
    websocketonerror(e) {
      // 错误
    },
    websocketonmessage(e) {
      const obj = JSON.parse(e.data);
      if (obj.cmd == "print") {
        if (obj.status == "failed") {
          this.$confirm(obj.msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          });
        }
      }
    },
    websocketsend(agentData) {
      // 数据发送
      this.websock.send(agentData);
    },
    websocketclose(e) {
      // 关闭
    },

    search() {
      this.form.page = 1;
      this.form.is_excel = 0;
      this.loading = true;

      this.fetchData(true);
    },

    fetchCondition() {
      if (
        this.$route.query.wave_picking_summary_id &&
        undefined == this.form.wave_picking_summary_id
      ) {
        this.form.wave_picking_summary_id =
          this.$route.query.wave_picking_summary_id;
      }
      if (this.$route.query.type && undefined == this.form.type) {
        this.type = parseInt(this.$route.query.type);
        if (this.type == 4) this.form.type = 1;
        if (this.type == 5) this.form.type = 3;
      }
      this.$http
        .post("/erp/WavePicking/getWavePickingCondition", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.conditionData = res.data.data;
            this.$message.error(res.data.msg);
          } else {
            this.conditionData = res.data.data;
            this.origin = parseInt(res.data.data.user_origin);
            if (this.form.wave_picking_summary_id) {
              this.fetchData();
            }
          }
        });
    },

    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      if (
        this.$route.query.wave_picking_summary_id &&
        undefined == this.form.wave_picking_summary_id
      ) {
        this.form.wave_picking_summary_id =
          this.$route.query.wave_picking_summary_id;
      }
      if (this.search_value != "") {
        for (const key in this.search_options) {
          this.form[this.search_options[key].key] = "";
        }
        this.form[this.search_type] = this.search_value;
      } else {
        for (const key in this.search_options) {
          this.form[this.search_options[key].key] = "";
        }
      }
      if (this.$route.query.is_remark) {
        if (this.$route.query.is_remark == 5) {
          this.form.is_remark = 0;
        } else {
          this.form.is_remark = 1;
        }
      }
      if (this.$route.query.type && undefined == this.form.type) {
        this.type = parseInt(this.$route.query.type);
        if (this.type == 4) this.form.type = 1;
        if (this.type == 5) this.form.type = 3;
      }
      this.form.multipleSelection = [];
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          // this.origin = parseInt(this.resData.data.origin);
          // this.splitData(this.resData);
        }
      });

      this.$http
        .post("/erp/WavePicking/getWavePickingCondition", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.conditionData = res.data.data;
            this.$message.error(res.data.msg);
          } else {
            this.conditionData = res.data.data;
          }
        });
    },
    splitData(val) {
      for (const key in val.data) {
        this.resData.data[key].order_sn = val.data[key].order_sn.split("\r\n");
        this.resData.data[key].custom_note =
          val.data[key].custom_note.split("\r\n");
        this.resData.data[key].admin_note =
          val.data[key].admin_note.split("\r\n");
      }
    },
    getCity(value) {
      // this.form.province = value;
      this.$http
        .post("/erp/WavePicking/getCity", { province: value })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.cityData = res.data.data;
          }
        });
    },
    getDistrict(value) {
      // this.form.city = value;
      this.$http
        .post("/erp/WavePicking/getDistrict", { city: value })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.districtData = res.data.data;
          }
        });
    },
    importFileWeight(res, fileList) {
      this.fileList = []; // 删除下方文件名
      if (res.code !== 200) {
        if (res.code == 201) {
          this.$confirm(res.data.str + res.data.out_err, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          });
        } else {
          this.$message.error(res.msg);
        }
      } else {
        this.dialogFormVisible = false;
        this.$message({
          type: "success",
          message: res.msg,
        });
        this.form.fileList = [];
        this.fetchData();
      }
    },
    importFileExpress(res, fileList) {
      if (res.code !== 200) {
        this.$message.error(res.msg);
      } else {
        this.form.fileList = res.data;
      }
    },
    importExpress() {
      this.form.origin = this.origin;
      this.loading = true;
      this.$http
        .post("/erp/WavePicking/importExpress", this.filteredForm)
        .then((res) => {
          this.loading = false;
          this.dialogFormVisible = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.form.is_excel = 0;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message({
                type: "success",
                message: res.data.data,
              });
              this.fileList = [];
              this.form.fileList = [];
              this.form.express = null;
              this.fetchData();
            }
          }
        });
    },
    exportExpress() {
      this.form.is_excel = 1;
      this.loading = true;
      this.$http
        .post("/erp/AsWavePicking/exportExpress", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.loading = false;
            this.form.is_excel = 0;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
    deleteWavePicking() {
      this.form.status_id = 6;
      this.$confirm("是否确定作废此波次?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/WavePicking/updateWavePickingStatus", this.filteredForm)
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message({
                  type: "info",
                  message: res.data.msg,
                });
              } else {
                this.$message({
                  type: "success",
                  message: "作废成功!",
                });
                this.fetchData();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消作废",
          });
        });
    },
    waybillDiscard() {
      this.form.status_id = 6;
      this.$confirm("是否确定取消面单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/AsWavePicking/waybillDiscard", this.filteredForm)
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message({
                  type: "info",
                  message: res.data.msg,
                });
              } else {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.fetchData();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 执行打印配货单
    printWavePicking() {
      this.form.status_id = 2;

      this.$confirm("是否确定打印配货单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/AsWavePicking/printPhd", this.filteredForm)
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message({
                  type: "info",
                  message: res.data.msg,
                });
              } else {
                this.form.multipleSelection = [];
                this.$refs.multipleTable.clearSelection();
                this.$message({
                  type: "success",
                  message: "进入打印页面!",
                });
                this.fetchData();
                const routeData = this.$router.resolve({
                  name: `wavepicking/printwavepicking/${res.data.data}/0/${this.origin}?type=4`,
                });
                window.open(routeData.href + routeData.route.name, "_blank");
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消打印",
          });
        });
    },

    resetCondition() {
      this.form = {
        is_remark: "",
        order_create_time: this.defaultDate(),
        create_time: this.searchDate(),
        province: [],
        city: [],
        district: [],
      };
      this.search_value = "";
    },

    // 字段显示设置
    changeFields(fields) {
      this.showFields = fields;
    },

    // 拦截
    // action {1: 去拦截, 2:取消拦截}
    toStop(wave_picking_id, action, rowIndex) {
      // 获取拦截内容
      const wave_picking_type = 2;
      if (action == 1) {
        return this._doStop(
          "",
          wave_picking_id,
          action,
          rowIndex,
          wave_picking_type
        );
      }
      this.$http
        .post("/erp/WavePicking/stopShippingGet", {
          wave_picking_id,
          wave_picking_type,
        })
        .then((rs) => {
          this._doStop(
            rs.data.data,
            wave_picking_id,
            action,
            rowIndex,
            wave_picking_type
          );
        });
    },

    _doStop(value, wave_picking_id, action, index, wave_picking_type) {
      const _text = action == 1 ? "拦截" : "取消拦截";
      this.$prompt("", _text, {
        inputType: "textarea",
        inputValue: value,
      })
        .then((rs) => {
          console.log("comfirm", index);
          this.$http
            .post("/erp/WavePicking/stopShippingSave", {
              wave_picking_id,
              desc: rs.value,
              wave_picking_type,
              is_stop_shipping: action,
            })
            .then((rs) => {
              if (rs.data.code != 200) return this.$message.error(rs.data.msg);
              this.$message.success("拦截成功");
              this.$set(this.resData.data[index], "is_stop_shipping", action);
            });
        })
        .catch((_) => {
          // |'_'|//
        });
    },

    // 恢复波次的初始收件人信息
    recoveryConsignee(is_check) {
      const { wave_picking_id } = this;
      this.$http
        .post("/erp/AsWavePicking/recoverWavePickingConsignee", {
          wave_picking_id,
          is_check,
        })
        .then((rs) => {
          if (rs.data.code != 200) {
            return this.$confirm(rs.data.msg, "错误提醒", {
              closeOnClickModal: false,
              showCancelButton: false,
            });
          }
          if (is_check == 1) {
            return this.$confirm(
              "收件信息是否确认恢复为原下单的收件信息",
              "恢复至下单的收件信息",
              {
                closeOnClickModal: false,
              }
            ).then((_) => {
              this.recoveryConsignee(0);
            });
          }

          this.$message.success(rs.data.msg);
          this.fetchData(true);
          this.form.change_province = "";
          this.form.change_city = "";
          this.form.change_district = 0;
          this.form.change_address = "";
          this.changeAddressVisible = false;
        });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>
<style>
.el-table .stock-row {
  background: #f7fd7b;
}
</style>



// WEBPACK FOOTER //
// src/pages/aswavepicking/AsWavePickingList.vue